import "@/style.scss";
const Loader = ({ className = "" }) => <div className={"spinner " + className}></div>;
export default Loader;
